import React from 'react';
import { connect } from 'react-redux';

import LinkEntry from './LinkEntry.jsx';

const Links = ({ links, offline }) => {
  if (offline) {
    return null;
  }
  return (
    <div>
      <h3 className="title">Liens utiles</h3>
      <div className="encart-lien-util">
        {
          links.map(link => (
            <LinkEntry key={link.id} link={link}/>
          ))
        }
      </div>
    </div>
  );
};

export default connect(state => ({
  links: state.links.data,
  offline: state.appState.offline,
}))(Links);



// WEBPACK FOOTER //
// ./book/src/links/Links.jsx